<template>
  <ul class="kt-menu__nav">
    <li
      v-if="hasPermissions(['offers-create'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('offer') }"
    >
      <router-link to="/offer" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon2-delivery-truck"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.OFFER") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['offers-create'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('quick-offer') }"
    >
      <router-link to="/quick-offer" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-add"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.QUICK_ADD") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['offers-view-self', 'offers-view-team', 'offers-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('list-offers') }"
    >
      <router-link to="/list-offers" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon2-files-and-folders"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.LIST_OFFERS") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['live-list-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('live-list') }"
    >
      <router-link to="/live-list" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-list"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.LIVE_LIST") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['price-lists-view-self', 'price-lists-view-team', 'price-lists-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('price-lists') }"
    >
      <router-link to="/price-lists" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-price-tag"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.PRICE_LISTS") }}</span>
      </router-link>
    </li>

    <!-- <li
      v-if="hasPermissions(['pricing-view-self', 'pricing-view-team', 'pricing-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('list-price') }"
    >
      <router-link to="/list-price" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-price-tag"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.PRICING") }}</span>
      </router-link>
    </li> -->

    <li
      v-if="hasPermissions(['companies-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('companies') }"
    >
      <router-link to="/companies" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-buildings"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.COMPANIES") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['company-contacts-view-all'])"
      class="kt-menu__item"
      aria-haspopup="true"
      :class="{ 'kt-menu__item--active': isPageActive('company-contacts') }"
    >
      <router-link to="/company-contacts" class="kt-menu__link">
        <i class="kt-menu__link-icon flaticon-businesswoman"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.COMPANY_CONTACTS") }}</span>
      </router-link>
    </li>

    <li
      v-if="hasPermissions(['pipelines-view-all', 'pipelines-create', 'pipelines-edit'])"
      class="kt-menu__item kt-menu__item--submenu"
      aria-haspopup="true"
      data-ktmenu-submenu-toggle="hover"
      :class="{
        'kt-menu__item--open kt-menu__item--here':
          isExpanded('pipelines') ||
          isPageActive(['pipelines-list', 'pipelines/create']) ||
          ['pipelines-view', 'pipelines-edit'].includes($route.name),
      }"
      @click="onMenuClick('pipelines', $event)"
    >
      <router-link to="" class="kt-menu__link kt-menu__toggle">
        <i class="kt-menu__link-icon flaticon2-layers-1"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.PIPELINES") }}</span>
        <i class="kt-menu__ver-arrow la la-angle-right"></i>
      </router-link>
      <div class="kt-menu__submenu">
        <span class="kt-menu__arrow"></span>
        <ul class="kt-menu__subnav">
          <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
            <span class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.PIPELINES") }}</span>
            </span>
          </li>

          <template
            v-if="hasPermissions(['pipelines-view-all']) && hasPermissions(['deals-view-all', 'deals-view-self'])"
          >
            <li
              v-for="p in pipelineOptions"
              :key="'pipeline-menu-' + p.id"
              class="kt-menu__item"
              aria-haspopup="true"
              :class="{
                'kt-menu__item--active':
                  $route.name === 'pipelines-view' &&
                  String($route.params.id) === String(p.id),
              }"
            >
              <router-link
                :to="{ name: 'pipelines-view', params: { id: String(p.id) } }"
                class="kt-menu__link"
              >
                <i class="kt-menu__link-icon flaticon2-layers-1"></i>
                <span class="kt-menu__link-text">{{ p.label }}</span>
              </router-link>
            </li>
          </template>

          <li
            v-if="hasPermissions(['pipelines-create'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive(['pipelines/create']) }"
          >
            <router-link to="/pipelines/create" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-add"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.CREATE_PIPELINE") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['pipelines-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('pipelines-list') }"
          >
            <router-link to="/pipelines-list" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-files-and-folders"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.LIST_PIPELINES") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>

    <li
      v-if="hasPermissions([
        'deals-view-all',
        'deals-view-self',
        'deal-types-view-all',
        'deal-types-create',
        'deal-types-edit',
        'deal-statuses-view-all',
        'deal-statuses-create',
        'deal-statuses-edit',
        'deal-document-types-view-all',
        'deal-document-types-create',
        'deal-document-types-edit',
      ])"
      class="kt-menu__item kt-menu__item--submenu"
      aria-haspopup="true"
      data-ktmenu-submenu-toggle="hover"
      :class="{
        'kt-menu__item--open kt-menu__item--here':
          isExpanded('deals') ||
          isPageActive(['deal-types', 'deal-statuses', 'deal-document-types', 'deals-list']),
      }"
      @click="onMenuClick('deals', $event)"
    >
      <router-link to="" class="kt-menu__link kt-menu__toggle">
        <i class="kt-menu__link-icon flaticon2-contract"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEALS") }}</span>
        <i class="kt-menu__ver-arrow la la-angle-right"></i>
      </router-link>
      <div class="kt-menu__submenu">
        <span class="kt-menu__arrow"></span>
        <ul class="kt-menu__subnav">
          <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
            <span class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEALS") }}</span>
            </span>
          </li>
          <li
            v-if="hasPermissions(['deals-view-all', 'deals-view-self'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('deals-list') }"
          >
            <router-link to="/deals-list" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-list-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEALS_LIST") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['deal-types-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('deal-types') ||
                ['deal-types-create', 'deal-types-edit'].includes($route.name),
            }"
          >
            <router-link to="/deal-types" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-list-3"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEAL_TYPES") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['deal-statuses-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('deal-statuses') ||
                ['deal-statuses-create', 'deal-statuses-edit'].includes($route.name),
            }"
          >
            <router-link to="/deal-statuses" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-list-2"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEAL_STATUSES") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['deal-document-types-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('deal-document-types') ||
                ['deal-document-types-create', 'deal-document-types-edit'].includes($route.name),
            }"
          >
            <router-link to="/deal-document-types" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-file"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.DEAL_DOCUMENT_TYPES") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>

    <li
      v-if="hasPermissions([
        'stock-inventory-view-all',
        'stock-receipts-view-all',
        'stock-purchase-orders-view-all',
        'stock-sales-orders-view-all',
        'stock-transport-orders-view-all',
        'stock-invoices-view-all',
        'stock-sales-view-all',
        'stock-transfer-orders-view-all',
        'stock-revisions-view-all',
      ])"
      class="kt-menu__item kt-menu__item--submenu stock-color"
      aria-haspopup="true"
      data-ktmenu-submenu-toggle="hover"
      :class="{
        'kt-menu__item--open kt-menu__item--here':
          isExpanded('stock') ||
          isPageActive(['stock/inventory', 'stock/average-costs', 'stock/invoices', 'stock/movements', 'stock/product-movements', 'stock/transfer-orders', 'stock/purchase-orders', 'stock/sales-orders', 'stock/delivery-notes', 'stock/transport-orders', 'stock/revisions', 'stock/receipts', 'stock/sales']),
      }"
      @click="onMenuClick('stock', $event)"
    >
      <router-link to="" class="kt-menu__link kt-menu__toggle">
        <i class="kt-menu__link-icon flaticon2-box"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK") }}</span>
        <i class="kt-menu__ver-arrow la la-angle-right"></i>
      </router-link>
      <div class="kt-menu__submenu">
        <span class="kt-menu__arrow"></span>
        <ul class="kt-menu__subnav">
          <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
            <span class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK") }}</span>
            </span>
          </li>
          <li
            v-if="hasPermissions(['stock-inventory-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/inventory') }"
          >
            <router-link to="/stock/inventory" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-list-3"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_INVENTORY") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-inventory-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/average-costs') }"
          >
            <router-link to="/stock/average-costs" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-chart"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_AVERAGE_COSTS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-invoices-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/invoices') }"
          >
            <router-link to="/stock/invoices" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-file-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_INVOICES") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-receipts-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive(['stock/movements', 'stock/receipts']) }"
          >
            <router-link to="/stock/movements" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-delivery-truck"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_MOVEMENTS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-receipts-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/product-movements') }"
          >
            <router-link to="/stock/product-movements" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-layers-2"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PRODUCT_MOVEMENTS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-transfer-orders-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/transfer-orders') }"
          >
            <router-link to="/stock/transfer-orders" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-lorry"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_TRANSFER_ORDERS") }}</span>
              <span
                v-if="stockTransferOrderActionableTotal > 0"
                class="kt-menu__link-badge"
              >
                <span class="kt-badge kt-badge--danger kt-badge--rounded">
                  {{ stockTransferOrderActionableTotal }}
                </span>
              </span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-purchase-orders-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/purchase-orders') }"
          >
            <router-link to="/stock/purchase-orders" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-shopping-cart"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PURCHASE_ORDERS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-sales-orders-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/sales-orders') }"
          >
            <router-link to="/stock/sales-orders" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-shopping-cart-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_SALES_ORDERS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-delivery-notes-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/delivery-notes') }"
          >
            <router-link to="/stock/delivery-notes" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-clipboard"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_DELIVERY_NOTES") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-transport-orders-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/transport-orders') }"
          >
            <router-link to="/stock/transport-orders" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-truck"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_TRANSPORT_ORDERS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-revisions-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/revisions') }"
          >
            <router-link to="/stock/revisions" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-checking"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_REVISIONS") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>

    <li
      v-if="hasPermissions([
        'stock-products-view-all',
        'stock-product-departments-view-all',
        'stock-product-categories-view-all',
        'stock-packagings-view-all',
        'stock-units-view-all',
        'stock-warehouses-view-all',
      ])"
      class="kt-menu__item kt-menu__item--submenu stock-color"
      aria-haspopup="true"
      data-ktmenu-submenu-toggle="hover"
      :class="{
        'kt-menu__item--open kt-menu__item--here':
          isExpanded('stock-settings') ||
          isPageActive(['stock/products', 'stock/product-departments', 'stock/product-categories', 'stock/packagings', 'stock/units', 'stock/warehouses']),
      }"
      @click="onMenuClick('stock-settings', $event)"
    >
      <router-link to="" class="kt-menu__link kt-menu__toggle">
        <i class="kt-menu__link-icon flaticon2-settings"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_SETTINGS") }}</span>
        <i class="kt-menu__ver-arrow la la-angle-right"></i>
      </router-link>
      <div class="kt-menu__submenu">
        <span class="kt-menu__arrow"></span>
        <ul class="kt-menu__subnav">
          <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
            <span class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_SETTINGS") }}</span>
            </span>
          </li>
          <li
            v-if="hasPermissions(['stock-products-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/products') }"
          >
            <router-link to="/stock/products" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-box-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PRODUCTS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-product-departments-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/product-departments') }"
          >
            <router-link to="/stock/product-departments" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-layers"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PRODUCT_DEPARTMENTS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-product-categories-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/product-categories') }"
          >
            <router-link to="/stock/product-categories" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-layers-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PRODUCT_CATEGORIES") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-packagings-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/packagings') }"
          >
            <router-link to="/stock/packagings" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-box"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_PACKAGINGS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-units-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/units') }"
          >
            <router-link to="/stock/units" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-list-2"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_UNITS") }}</span>
            </router-link>
          </li>
          <li
            v-if="hasPermissions(['stock-warehouses-view-all'])"
            class="kt-menu__item stock-color"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('stock/warehouses') }"
          >
            <router-link to="/stock/warehouses" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-cube"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.STOCK_WAREHOUSES") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>

    <li
      v-if="hasPermissions([
        'users-view-self',
        'users-view-team',
        'users-view-all',
        'teams-view-self',
        'teams-view-team',
        'teams-view-all',
        'aliases-view-self',
        'aliases-view-team',
        'aliases-view-all',
        'mappings-view-self',
        'mappings-view-team',
        'mappings-view-all',
        'unit-conversions-view-all',
        'unit-conversions-create',
        'unit-conversions-edit',
        'transport-data-view-self',
        'transport-data-view-team',
        'transport-data-view-all',
        'field-tags-view-all',
        'field-tags-create',
        'field-tags-edit',
        'incoterms-view-all',
        'incoterms-create',
        'incoterms-edit',
        'price-config-view-self',
        'price-config-view-team',
        'price-config-view-all'
      ])"
      class="kt-menu__item kt-menu__item--submenu"
      aria-haspopup="true"
      data-ktmenu-submenu-toggle="hover"
      :class="{
        'kt-menu__item--open kt-menu__item--here': isExpanded('settings') || isPageActive([
          'users',
          'teams',
          'aliases',
          'mappings',
          'unit-conversions',
          'transport-data',
          'field-tag-types',
          'incoterms',
          'price-config'
        ]),
      }"
      @click="onMenuClick('settings', $event)"
    >
      <router-link to="" class="kt-menu__link kt-menu__toggle">
        <i class="kt-menu__link-icon flaticon-settings"></i>
        <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.SETTINGS") }}</span>
        <i class="kt-menu__ver-arrow la la-angle-right"></i>
      </router-link>
      <div class="kt-menu__submenu">
        <span class="kt-menu__arrow"></span>
        <ul class="kt-menu__subnav">
          <li class="kt-menu__item kt-menu__item--parent" aria-haspopup="true">
            <span class="kt-menu__link">
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.SETTINGS") }}</span>
            </span>
          </li>

          <li
            v-if="hasPermissions(['users-view-self', 'users-view-team', 'users-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('users') }"
          >
            <router-link to="/users" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-users"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.USERS") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['teams-view-self', 'teams-view-team', 'teams-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('teams') }"
          >
            <router-link to="/teams" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-group"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.TEAMS") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['aliases-view-self', 'aliases-view-team', 'aliases-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('aliases') }"
          >
            <router-link to="/aliases" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-map"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.ALIASES") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['mappings-view-self', 'mappings-view-team', 'mappings-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('mappings') }"
          >
            <router-link to="/mappings" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-cube-1"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.MAPPINGS") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['unit-conversions-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('unit-conversions') ||
                ['unit-conversions-create', 'unit-conversions-edit'].includes($route.name),
            }"
          >
            <router-link to="/unit-conversions" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-background"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.UNIT_CONVERSIONS") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['transport-data-view-self', 'transport-data-view-team', 'transport-data-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('transport-data') }"
          >
            <router-link to="/transport-data" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-truck"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.TRANSPORT_DATA") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['price-config-view-self', 'price-config-view-team', 'price-config-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{ 'kt-menu__item--active': isPageActive('price-config') }"
          >
            <router-link to="/price-config" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon-price-tag"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.PRICE") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['field-tags-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('field-tag-types') || ['field-tags', 'field-tags-create', 'field-tags-edit'].includes($route.name),
            }"
          >
            <router-link to="/field-tag-types" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-tag"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.FIELD_TAGS") }}</span>
            </router-link>
          </li>

          <li
            v-if="hasPermissions(['incoterms-view-all'])"
            class="kt-menu__item"
            aria-haspopup="true"
            :class="{
              'kt-menu__item--active':
                isPageActive('incoterms') || ['incoterms-create', 'incoterms-edit'].includes($route.name),
            }"
          >
            <router-link to="/incoterms" class="kt-menu__link">
              <i class="kt-menu__link-icon flaticon2-delivery-truck"></i>
              <span class="kt-menu__link-text">{{ $t("MENU.ASIDE.INCOTERMS") }}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import userStateService from "@/common/userState.service.js";
import { GET_PIPELINE_OPTIONS } from "@/store/pipelines.module";
import { GET_STOCK_TRANSFER_ORDER_ACTIONABLE_SUMMARY } from "@/store/stock/stockTransferOrders.module";
import { mapGetters } from "vuex";

export default {
  name: "KTAsideMenu",
  data() {
    return {
      expandedMenus: userStateService.getState("layout.aside.expanded", {}),
    };
  },
  computed: {
    ...mapGetters([
      "pipelineOptions",
      "stockTransferOrderActionableTotal",
      "stockContextVersion",
    ]),
  },
  watch: {
    stockContextVersion() {
      this.loadTransferOrderActionableSummary();
    },
    "$route.path"() {
      this.loadTransferOrderActionableSummary();
    },
  },
  mounted() {
    this.loadPipelineOptions();
    this.loadTransferOrderActionableSummary();
  },
  methods: {
    loadPipelineOptions() {
      if (!this.hasPermissions(["pipelines-view-all"])) {
        return;
      }

      this.$store
        .dispatch(GET_PIPELINE_OPTIONS, {})
        .catch(() => {});
    },
    loadTransferOrderActionableSummary() {
      if (!this.hasPermissions(["stock-transfer-orders-view-all"])) {
        return;
      }

      this.$store
        .dispatch(GET_STOCK_TRANSFER_ORDER_ACTIONABLE_SUMMARY)
        .catch(() => {});
    },
    isPageActive(page) {
      return Array.isArray(page)
        ? page.some((p) => this.$route.path.indexOf(`/${p}`) > -1)
        : this.$route.path.indexOf(`/${page}`) > -1;
    },
    checkIsOpen() {
      const body = document.body;
      if (!body.classList.contains("kt-aside--minimize")) {
        return;
      }

      const toggler = document.getElementById("kt_aside_toggler");
      if (toggler) {
        toggler.setAttribute("out", true);
        toggler.click();
      }
    },
    isExpanded(menuKey) {
      return Boolean(this.expandedMenus[menuKey]);
    },
    onMenuClick(menuKey, event) {
      this.checkIsOpen();

      const isToggleClick = event.target.closest(".kt-menu__toggle");
      if (!isToggleClick) {
        return;
      }

      const menuItemElement = event.currentTarget;

      setTimeout(() => {
        const isOpen = menuItemElement.classList.contains("kt-menu__item--open");
        this.$set(this.expandedMenus, menuKey, isOpen);
        userStateService.setState("layout.aside.expanded", this.expandedMenus);
      }, 0);
    }
  }
};
</script>
